import enUS from './en-US';
import zhCN from './zh-CN';
import jaJP from './ja-JP';
var LOCALE_MESSAGES = {
  'en-US': enUS,
  'zh-CN': zhCN,
  'ja-JP': jaJP
};
export default LOCALE_MESSAGES;